import {IGlobalLocale} from "./locale.interface";

export const ru: IGlobalLocale = {
    module: {
        menu: {
            0: {
                title: "Клиенты", hint: "Справочник клиентов"
            }, 1: {
                title: "Счета", hint: "Справочник счетов"
            }, 2: {
                title: "Карты", hint: "Карты клиентов"
            }, 3: {
                title: "Отчёты", hint: "Отчёты"
            }, 4: {
                title: "Документация", hint: "Документация"
            }, 5: {
                title: "Настройки", hint: "Настройки"
            }, 6: {
                title: "Переводы средств", hint: "Переводы средств между счетами/картами"
            }, 7: {
                title: "Моя карта", hint: "Моя карта"
            }
        }, login: {
            enterCRM: 'Войти в CRM',
            welcomeText: 'Для входа ведите телефон и пароль или зарегистрируйтесь',
            titleLogin: 'Телефон',
            titlePassword: 'Пароль',
            btnRegister: 'Регистрация',
            btnForgotPass: 'Забыли пароль',
            btnEnter: 'Войти',
            btnLogout: 'Выйти'
        }, register: {
            registerCRM: 'Регистрация',
            updateCRM: 'Замена пароля',
            welcomeTextPhone: 'Для регистрации или напоминания, пожалуйста введите номер телефона',
            welcomeTextOTP: 'Введите код, который Вам было отправлено в СМС на указанный номер телефона',
            titlePhone: 'Телефон',
            titleOTP: 'Код из СМС',
            btnRegisterPhone: 'Отправить СМС-код',
            btnRegisterOTP: 'Зарегистрироваться',
            btnUpdatePassOTP: 'Обновить данные',
            titleEnterPass: 'Введите пароль',
            titleEnterRePass: 'Повтор пароля',
            titleRegisterDriver: 'Ваш номер телефона "%1%", будет привязан к карте "%2%". Подтверждаете это действие?',
            titleRegisterDriverSuccess: 'Номер телефона "%1%", успешно подвязан к карте "%2%". Далее Вам необходимо пройти регистрацию.'
        }, clientList: {
            placeholderSearchString: 'Поиск по названию или ОКПО',
            titleAccounts: 'Счета',
            titlePage: 'Клиенты',
            titleID: 'ID',
            titleNameClient: 'Название клиента',
            titleOKPO: 'ОКПО',
            titleINN: 'ИНН',
            titlePhone: 'Телефон',
            titleEmail: 'Почта',
            titleAddress: 'Адрес',
            titleLegalAddress: 'Юридический адрес',
            titleNumContract: 'Номер договора',
            titleStatus: 'Статус клиента',
        }, accounts: {
            titleID: 'ID',
            titleRemark: 'Описание',
            titleRest: 'Остаток',
            titleOverdraft: 'Овердрафт',
            titleTotalBalance: 'Баланс счета',
            titleTotalBalanceHint: 'Доступно',
            titlePurses: 'Кошельки',
            titleTotalBalanceWithoutHold: 'Баланс',
            titleTotalBalanceWithoutHoldHint: 'Баланс счета без учёта холда',
            titleCardsQty: 'Карты(кол-во)',
            titleCards: 'Карты',
            btnAccountLink: 'Перейти к счетам'
        }, cards: {
            titleID: 'Карта',
            titleVin: 'Авто',
            titlePhone: 'Телефон',
            titleName: 'Фамилия, имя',
            titleActiveMobileApp: 'Мобильное приложение',
            titleSetting: 'Налаштування',
            titleConfirmRenewPin: 'Вы действительно хотите заменить текущий pin?',
            titleShowNewPin: 'Новый PIN',
            titleBtnSendOtp: 'Отправить код',
            titleBtnSendRegisterLink: 'Отправить ссылку на регистрацию',
            titleCodeFromSMS: 'Код из смс',
            titleBtnCommit: 'Заменить номер',
            limits: {
                titleBtnAddLimit: 'Добавить лимит',
                titleMoneySchema: 'Гривневая схема',
                titleQtySchema: 'Литровая схема',
                titleShortMoneySchema: 'Гривневая',
                titleShortQtySchema: 'Литровая',
                titlePurses: 'Кошельки',
                titleSchemaType: 'Схема',
                titleType: 'Тип',
                titleMoneyByDay: 'Грн/Сутки',
                titleQtyByDay: 'Літри/Сутки',
                titleMoneyByMonth: 'Грн/Месяц',
                titleQtyByMonth: 'Літри/Месяц',
                titleBalance: 'Оборот',
                titleLimitAmount: 'Лимит',
                titleRest: 'Остаток',
                titleMoneyByOnce: 'Грн/Разово',
                titleQtyByOnce: 'Літри/Разово',
                titleMoneyByWeek: 'Грн/Неделя',
                titleQtyByWeek: 'Літри/Неделя',
                titleMoneyOutOfTime: 'Грн.до списання',
                titleQtyOutOfTime: 'Літри до списання',
                newLimit: {
                    title: 'Счёт',
                    titleIndividual: 'Индивидаульный',
                    titleCommon: 'Общий',
                    titleTypeLimit: 'Тип лимита',
                    titleLimitAmount: 'Сумма'
                }
            },
            qr: {
                notExistCard: "Карта отсутствует. Чтобы добавить карту, привяжите свой номер телефона к карте",
                notMatchResolution: "не походит разрешение экрана, пожалуйста, поверните телефон",
                contextMenu: {
                    blocked: 'Заблокировать',
                    confirmBlockedCard: 'Вы действительно хотите заблокировать карту?',
                    limits: 'Просмотр лимитов'
                },
                status: {
                    0: "Заблокирована", 1: "Активная"
                }
            }
        }, transfer: {
            titleAccountSource: 'Откуда',
            titleAccountSourceHelper: 'Выберите откуда',
            titleAccountDestination: 'Куда',
            titleAccountDestinationHelper: 'Выберите куда',
            titleTransferButton: 'Выполнить перевод',
            confirmTransfer: 'Вы уверены, что хотите осуществить этот перевод?'
        }, reports: {
            titleTrnKind: 'Вид отчёта',
            titleDate: 'Дата',
            titleCard: 'Карта',
            titleAddress: 'Адрес АЗС',
            titlePurse: 'Кошелек',
            titleQty: 'Кол-во',
            titlePrice: 'Цена',
            titleSum: 'Сумма',
            titleDiscount: 'Скидка',
            titleSumWithDiscount: 'Сумма со скидкой',
            titleName: 'Название',
            titleUseFromDate: 'От даты',
            titleUseToDate: 'До даты',
            titleSubmitXLS: 'Сохранить в EXCEL',
            tittleFilterClear: 'Очистить'
        }, billing: {
            fileName: 'Счет_от_%1%',
            typeFuel: 'Оплата за нефтепродукты',
            typeGoods: 'Оплата за товар',
            titleBtnCreateInvoice: 'Сформировать счёт',
            titleLoadingFile: 'Формирование счёта...',
            titleLoadingFileError: "Не удалось отобразить файл",
            titleBtnSaveXLSX: 'Сохранить XLSX',
            titleBtnSavePDF: 'Сохранить PDF'
        }, setting: {
            titleChangePass: 'Сменить пароль',
            titleChangeUser: 'Пользователи',
            titleAddNewUser: 'Добавить нового пользователя',
            users: {
                titleAccountId: 'ID',
                titleAccountRemark: 'Описание',
                titleFio: 'Фамилия, имя',
                titleFirstName: 'Имя',
                titleLastName: 'Фамилия',
                titlePhone: 'Телефон',
                titleEmail: 'Email',
                titleApiRole: 'Роль'
            }
        }, dataGroup: {
            infoClient: 'Информация клиента',
            accounts: 'Счета',
            analytics: 'Аналитика',
            limits: 'Лимиты',
            additionalInfo: 'Дополнительная информация',
            analyticInfo: 'Аналитика'
        }, common: {
            table: {
                num: '#',
                active: 'Статус',
                filter: 'Фильтр',
                clearFilter: 'Очистить фильтр',
                emptyRows: 'Строки отсутствуют',
                setting: 'Настройки'
            }, filter: {
                title: 'Фильтр',
                titleSubmit: 'Применить',
                titleStatus: 'Статус',
                titleIsActive: 'Активный',
                titleInactive: 'Не активний',
                titleIsBlock: 'Заблокировано',
                titleBalance: 'Баланс',
                titleNumCard: 'Номер карты',
                titlePhone: 'Телефон',
                titleVIN: 'Авто',
                titleFirstName: 'Имя',
                titleLastName: 'Фамилия',
                titleFrom: 'От',
                titleTo: 'До',
                titleAccountName: 'Название',
                titleSelectAll: 'Все'
            }, title: {
                backToClients: 'Назад к списку клиентов',
                backToCards: 'Назад к списку карт',
                backToAccounts: 'Назад к списку счетов',
                titleClientComboBox: 'Клиент',
                titleAccountComboBox: 'Счет',
                titleCards: 'Карты',
                titleDataNotFound: 'Данные не найдены',
                titleNotInitialized: 'Не определено',
                titleCancel: 'Отмена',
                titlePeriod: 'Период',
                titleDocumentation: 'Документация',
                titleLinks: 'Ссылки',
                titleSearchStr: 'Строка поиска',
                titleSelected: 'Выбрано',
                titleNext: 'Далее',
                titleBack: 'Назад',
                titleCommit: 'Выполнить',
                titleSum: 'Сумма',
                titleOr: 'Или',
                titleCreate: 'Создать',
                titleDelete: 'Удалить',
            }, modal: {
                type: {
                    info: 'Информация',
                    success: 'Успешное выполнение',
                    warning: 'Предупреждение',
                    error: 'Ошибка',
                    confirmation: 'Подтверждение',
                    default: ''
                }, labelConfirmation: 'Вы действительно хотите удалить строку?'
            }
        }
    }, statusClient: {
        0: "Активный", 1: "Заблокированный", 2: "Удаленный", 3: "Перемещенный"
    }, error: {
        0: "Нет ошибки",
        1: "Введенный данные не являюся номером телефона",
        2: "Номер телефона не найден",
        3: "Неверный OTP",
        4: "Користувач був зареєстрований раніше",
        5: "Користувач не знайдений",
        6: "Невірний пароль або номер телефону (email)",
        7: "Доступ до рахунку заблокований",
        8: "Ошибочные параметры",
        9: "Ошибка при создании лимита",
        10: "Не удалось установить новый пин",
        18: "Не удалось обонвить лимит",
        1000: "Неизвестная ошибка",
        1001: "Пользователь не авторизован",
        1002: "Операция выполнена успешно",
        1003: "Во время выполнения произошла ошибка",
        1004: "Не корректный номер телефона",
        1005: "Ошибка запроса",
        1006: "Запрос не авторизован",
        validation: {
            fieldRequired: 'Обзательное поле', fieldErrorEmail: 'Некорректный email'
        }
    }
}
